import { render } from "./SpecificObjectives.vue?vue&type=template&id=7d263b52"
import script from "./SpecificObjectives.vue?vue&type=script&lang=js"
export * from "./SpecificObjectives.vue?vue&type=script&lang=js"

import "./SpecificObjectives.vue?vue&type=style&index=0&id=7d263b52&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__